<div class="confirmation-modal">
  <div mat-dialog-title class="title">
    {{title}}
  </div>

  <div mat-dialog-content class="message">
    <p *ngIf="!isHtmlContent">{{message}}</p>
    <div *ngIf="isHtmlContent" [innerHTML]="message"></div>
  </div>

  <div  fxLayout fxLayoutAlign="flex-end center" [fxLayoutGap]="buttonsGap" [class]="'buttons-list' + (showTertiaryBtn ? ' three-buttons' : '')">
    <cm-button color="secondary" *ngIf="showCancelBtn && !borderCancelBtn" fxFlex="100px" (click)="onDismiss()">{{cancelButtonText}}</cm-button>
    <!-- <a *ngIf="showCancelBtn && !borderCancelBtn" class="cancel-link" (click)="onDismiss()">{{ cancelButtonText }}</a> -->

    <ng-container *ngIf="!freeSizeBtn">
    <cm-button color="secondary" (click)="onDismiss()" *ngIf="showCancelBtn && borderCancelBtn" fxFlex="100px">{{cancelButtonText}}</cm-button>
    <cm-button [color]="tertiaryButtonColor" (click)="onTertiary()" *ngIf="showTertiaryBtn" fxFlex="100px">{{tertiaryButtonText}}</cm-button>
    <cm-button color="primary" fxFlex="120px" (click)="onConfirm()">{{submitButton}}</cm-button>
    </ng-container>
    <ng-container *ngIf="freeSizeBtn">
      <cm-button color="secondary" (click)="onDismiss()" *ngIf="showCancelBtn && borderCancelBtn" fxFlex="100px">{{cancelButtonText}}</cm-button>
      <cm-button [color]="tertiaryButtonColor" (click)="onTertiary()" *ngIf="showTertiaryBtn" fxFlex="100px">{{tertiaryButtonText}}</cm-button>
      <cm-button color="primary" fxFlex="120px" (click)="onConfirm()">{{submitButton}}</cm-button>
    </ng-container>

    <!-- <cm-button (click)="onConfirm()">{{submitButton}}</cm-button> -->
  </div>
</div>

